import React from 'react';
import Widget from 'components/ui/layout/panel/Widget';
import Icon from 'components/ui/element/Icon';

const NotAuthorizedTemplate = ({formatMessage}) => (
    <div className="no-authorized-template no-modal">
        <Widget>
            <h1>{formatMessage({id: 'title.serviceNotFound.service'}, {service: 'Storage'})}</h1>
            <p>{formatMessage({id: 'notAuthorized.storage.description'})}</p>
            <ul>
                <li>{formatMessage({id: 'notAuthorized.storage.option1'})}</li>
                <li>{formatMessage({id: 'notAuthorized.storage.option2'})}</li>
            </ul>
            <p>{formatMessage({id: 'notAuthorized.storage.feature.title'})}</p>
            <ul>
                <li>{formatMessage({id: 'notAuthorized.storage.feature.option1'})}</li>
                <li>{formatMessage({id: 'notAuthorized.storage.feature.option2'})}</li>
                <li>{formatMessage({id: 'notAuthorized.storage.feature.option3'})}</li>
                <li>{formatMessage({id: 'notAuthorized.storage.feature.option4'})}</li>
                <li><b>{formatMessage({id: 'notAuthorized.storage.feature.option5.name'})}</b> {formatMessage({id: 'notAuthorized.storage.feature.option5.description'})}</li>
            </ul>

        </Widget>
        <Widget className="no-authorized-template__contact">
            <h1><Icon key={'envelope'} name={'envelope'} /> {formatMessage({id: 'label.contacts.contact'})}</h1>
            <p>{formatMessage({id: 'notAuthorized.contact'})}</p>
            <ul>
                <li><a href="mailto:Solutions.EMS.Spain@eu.equinix.com">Solutions.EMS.Spain@eu.equinix.com</a></li>
            </ul>
        </Widget>
    </div>
);

module.exports = NotAuthorizedTemplate;



// WEBPACK FOOTER //
// ./src/routes/no-authorized-templates/storage.js